<template>
    <div id="app">
        <!--Don't remove commented code-->
        <!-- <HeaderView v-if="this.$router.currentRoute.name != null"></HeaderView> -->
        <!-- <section class="content-main" v-if="this.$router.currentRoute.name != null"> -->
        <a href="#content-main" class="form-btn main-content-button">{{ $t('message.go-to-main-content') }}</a>
        <HeaderView></HeaderView>

        <section class="content-main" id="content-main">
            <div class="content-inside">
                <div class="container">
                    <div class="white-bg">
                        <main>
                            <keep-alive>
                                <router-view :key="$route.fullPath"></router-view>
                            </keep-alive>
                        </main>
                    </div>
                </div>
            </div>
        </section>

        <FooterView></FooterView>
        <!--Don't remove commented code-->
        <!-- <FooterView v-if="this.$router.currentRoute.name != null"></FooterView> -->
    </div>
</template>

<script>
    import HeaderView from "@/components/HeaderView";
    import FooterView from "@/components/FooterView";
    export default {
        name: "App",
        components: {
            HeaderView,
            FooterView
        }
    }
</script>
<style lang="scss">
    @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
    @import "./assets/scss/style.scss";
</style>
